import React from "react";

const Gift = () => {
	return (
		<div className="Gift-area pt--80 pb--60">
			<div className="container">
				<div className="col-12">
					<div className="section-title text-center">
						<h2>Un Regalo Speciale</h2>
						<p>
							Abbiamo scelto di partire per il Giappone, il viaggio dei nostri sogni, e
							sarebbe meraviglioso condividere questa esperienza con voi anche prima della
							partenza!
							<br />
							<br />
							Se desiderate contribuire, potete farlo tramite bonifico.
							<br />
							<br />
							<b>Intestatario</b>: Giulia Ferraro & Marco Santini
							<br />
							<b>IBAN</b>: IT60 X054 2811 1010 0000 0123 456
							<br />
							<b>Causale</b>: Contributo Viaggio di Nozze – Giulia & Marco
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Gift;
